import React, { useState, useEffect, useMemo } from 'react';
import { withNamespaces } from 'react-i18next';
import {
	makeStyles,
	Box,
	Grid,
	IconButton,
	InputBase,
	FormControl,
	Select,
	MenuItem,
} from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import SearchIcon from '@material-ui/icons/Search';

import qs from 'qs';

import { transformQuery } from '../../../../../../lib/helpers/queryTransformer';

const useStyles = makeStyles((theme) => ({
	root: {
		backgroundColor: '#FAFAF5',
		marginTop: 30,
		marginBottom: 30,
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-around',
	},
	searchBox: {
		width: '100%',
		height: 40,
		backgroundColor: '#F0F0EB',
		padding: 1,
		marginTop: 20,
		marginBottom: 20,
		marginLeft: 24,
		marginRight: 24,
		display: 'flex',
		alignItems: 'center',
	},
	iconButton: {
		borderRadius: 0,
		width: 38,
		height: 38,
		backgroundColor: '#FFFFFF',
		color: theme.palette.primary.dark,
	},
	input: {
		fontFamily: 'Ubuntu',
		marginLeft: 10,
		fontSize: '14px',
		letterSpacing: '0px',
		width: '60%',
		[theme.breakpoints.only('xs')]: {
			width: '50%',
		},
	},
	yearControl: {
		marginLeft: 16,
		minWidth: 100,
	},
	yearSelect: {
		height: 38,
		padding: '0 10px',
		backgroundColor: '#FFFFFF',
	},
	menuPaper: {
		maxHeight: 200,
	}
}));

export default withNamespaces('gazette')((props) => {
	const { t, category } = props;
	const classes = useStyles();

	const history = useHistory();

	const [query, setQuery] = useState({});
	const [search, setSearch] = useState(null);
	const [year, setYear] = useState('');

	const yearOptions = useMemo(() => {
		const current = new Date().getFullYear() + 1;
		const start = 2000;
		return Array.from({ length: current - start + 1 }, (_, i) => {
			const y = start + i;
			return { value: y, label: y.toString() };
		});
	}, []);

	useEffect(() => {
		setQuery(
			qs.parse(history.location.search, {
				ignoreQueryPrefix: true,
			}),
		);
	}, [history.location.search]);

	useEffect(() => {
		setSearch(query?.s ? query.s : null);
		setYear(query?.year ? String(query.year) : '');
	}, [query]);

	const handleSearch = () => {
		window.scrollTo(0, 0);

		const nextQuery = { ...query, s: search || '', page: 1 };
		if (year === '' || year === null) {
			delete nextQuery.year;
		} else {
			nextQuery.year = Number(year);
		}

		history.push({
			pathname: `/gazette/${category}`,
			search: transformQuery(nextQuery),
		});
	};

	return (
		<Grid container spacing={0} className={classes.root}>
			<Grid item className={classes.searchBox}>
				<Box display='flex' alignItems='center' width='100%'>
					<Box display='flex' alignItems='center' width='100%'>
						<IconButton className={classes.iconButton} onClick={handleSearch}>
							<SearchIcon />
						</IconButton>
						<InputBase
							onChange={(evt) => setSearch(evt.target.value)}
							value={search}
							className={classes.input}
							placeholder={t('search')}
							inputProps={{ 'aria-label': 'search news' }}
						/>
					</Box>
					<Box>
						<FormControl variant='standard' className={classes.yearControl}>
							<Select
								labelId='year-select-label'
								value={year}
								displayEmpty
								onChange={(e) => setYear(e.target.value)}
								className={classes.yearSelect}
								inputProps={{ 'aria-label': 'Year' }}
								MenuProps={{ classes: { paper: classes.menuPaper } }}>
								<MenuItem value='' disabled>{t('year')}</MenuItem>
								{yearOptions.map((opt) => (
									<MenuItem key={`year_${opt.value}`} value={String(opt.value)}>
										{opt.label}
									</MenuItem>
								))}
							</Select>
						</FormControl>
					</Box>
				</Box>
			</Grid>
		</Grid>
	);
});
